/* eslint-disable no-console */
import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { synopticApi } from 'services/apiDigitalTicket/synoptic';

// Actions
import { setOpenLoading, setClose } from 'store/ducks/dialogs/actions';
import { setOpen } from 'store/ducks/snackbars/actions';
import {
  listSynopticRequest,
  listSynopticSuccess,
  listSynopticFailure,
} from './actions';

// Types
import { SynopticTypes } from './types';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

function* list({ payload }: ReturnType<typeof listSynopticRequest>): any {
  try {
    yield put(setOpenLoading({ title: 'Carregando...' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(synopticApi.monitoringList, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        listSynopticSuccess({
          monitoringList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );
      yield put(setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('synoptic - monitoringList - error', error);
    yield put(
      setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(listSynopticFailure());
    yield put(setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const synopticSagas = [
  takeLatest(SynopticTypes.LIST_SYNOPTIC_REQUEST, list),
];
